<template>
  <div v-if="enable">
    <div class=" d-flex justify-center">
      <v-btn
        color="white"
        @click="$emit('scroll')"
        fixed
        class="button-top"
        top
      >
        <v-icon>mdi-arrow-up-bold-hexagon-outline</v-icon>
        Go Back
      </v-btn>
    </div>
    <div class=" d-flex justify-center">
      <v-btn
        color="white"
        :to="{ name: 'Catalogue' }"
        fixed
        bottom
        class="button-top"
        id="continue-interactive"
      >
        Continue
        <v-icon>mdi-arrow-down-bold-hexagon-outline</v-icon>
      </v-btn>
      <v-container>
        <v-btn
          color="white"
          @click="$emit('annotations')"
          fixed
          icon
          left
          class="annotation-button pa-9 "
          id="toggle-annotations"
        >
          <v-icon class="text-h3">
            mdi-tag-text-outline
          </v-icon>
        </v-btn>
        <v-btn
          color="white"
          @click="$tours['landingPageTour'].start()"
          fixed
          icon
          left
          class="annotation-button pa-9 mt-16 "
          id="repeat-landing-tour"
        >
          <v-icon class="text-h3">
            mdi-help-circle-outline
          </v-icon>
        </v-btn>
      </v-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InteractControlls',
  props: {
    enable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.annotation-button {
  z-index: 4;
  top: 44%;
}

.button-top {
  z-index: 4;
}

.button-bottom {
  z-index: 4;
}
</style>
